module.exports = __webpack_public_path__ + "img/Kuwait.e262204e.gif";